import React from "react"
import styled from "styled-components"
import {DoughnutChart} from "./DoughnutChart"

const BadgeChart = React.memo((props) => {
  return (
    <OuterDiv>
      <InnerDiv>
        <DoughnutChart
          colors={props.colors}
          labels={props.labels}
          values={props.values}
        />
      </InnerDiv>
    </OuterDiv>
  )
})

const InnerDiv = styled.div`
  height: 120px;
  margin-left: -32px;
  margin-top: -12px;
  width: 120px;
`

const OuterDiv = styled.div`
  height: 70px;
  margin-right: ${(props) => props.theme.gutter}px;
  width: 70px;
`

export {BadgeChart}
